import { render, staticRenderFns } from "./Pk_management.vue?vue&type=template&id=d2c3e4ca&"
import script from "./Pk_management.vue?vue&type=script&lang=js&"
export * from "./Pk_management.vue?vue&type=script&lang=js&"
import style0 from "./Pk_management.vue?vue&type=style&index=0&id=d2c3e4ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports